export const appRoutes = {
  root: '/',
  home: '',
  profile: 'profile',
  dashboard: 'dashboard',
  messages: 'messages',
  notifications: 'notifications',
  ad: 'ad',
  ads: 'ads',
  adList: 'ad-list',
  adCrate: 'ad-crate',
  adUpdate: 'ad-update',
  adCrateSimilar: 'ad-crate-similar',
  contactUs: 'contact-us',
  helpInformation: 'help-information',
  termsConditions: 'terms-conditions',
  privacyPolicy: 'privacy-policy',
  account: 'account',
  login: 'login',
  registration: 'registration',
  registrationConfirm: 'registration-confirm',
  registrationSuccess: 'registration-success',
  passwordRecovery: 'password-recovery',
  passwordRecoveryConfirm: 'password-recovery-confirm',
  passwordRecoverySuccess: 'password-recovery-success',
  paymentResponse: 'payment-response',
  successPayment: 'success',
  canceledPayment: 'canceled',
  notFound: 'not-found'
};
